import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminDreamersBlessing(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/dreamers-blessing`, { params, headers });
    return data;
}

export async function confirmDreamersBlessingPayment(id) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.post(`${host}/dreamers-blessing/${id}/confirm-payment`, {}, { headers });
    return data;
}

// The copy is served only with an admin token, so fetch it as a blob and hand back an object URL.
export async function getDreamersBlessingPassportCopy(id) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/dreamers-blessing/${id}/passport-copy`, { headers, responseType: 'blob' });
    return URL.createObjectURL(data);
}
